import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import type { useFormik } from "formik";
import type { WithRecipientsExistance } from "features/openBanking/types";
import { Checkbox, type CheckboxProps } from "ui/forms/formik-elements";
import RecipientTooltipTitle from "./RecipientTooltipTitle";

type Props =
    & Omit<CheckboxProps, 'label'>
    & Pick<ReturnType<typeof useFormik<WithRecipientsExistance>>, 'initialValues'>;

const ToggleEnabledOpenBankingResource = ({ initialValues, ...restProps }: Props) => (
    <Tooltip
        arrow
        placement='top-start'
        title={!initialValues.recipients_exist && (
            <RecipientTooltipTitle />
        )}
    >
        <Box
            sx={{
                width: 'min-content'
            }}
        >
            <Checkbox
                {...restProps}
                label='Enabled'
                CheckboxProps={{
                    inputProps: {
                        'aria-label': 'Enabled'
                    },
                    ...restProps.CheckboxProps,
                    disabled: !initialValues.recipients_exist
                }}
            />
        </Box>
    </Tooltip>
);

export default ToggleEnabledOpenBankingResource;
